import { Injectable } from '@angular/core';
import { WindowReferenceService } from './window-reference.service';

//export type AnalyticsEventNames = 'add_payment_info'

export interface AnalyticsButtonEventParams {
  event?: string;
  category?: string,
  action?: string,
  label?: string,
  value?: number;
}

interface AnalyticsEventParams extends AnalyticsButtonEventParams {
  pagePath?: string;
  pageTitle?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  constructor(
    private _windowRef: WindowReferenceService
  ) {
  }

  trackPageView(path: string, title: string = null)
  {
    this.sendToDataLayer({
      event: "content-view",
      pagePath: path,
      pageTitle: title,
    });
  }

  trackEvent(event: string, category: string, action: string, label: string, value: number = null)
  {
    this.sendToDataLayer({
      event: event,
      category: category,
      action: action,
      label: label,
      value: value
    });
  }

  private sendToDataLayer(hit: AnalyticsEventParams)
  {
    if (!this._windowRef.nativeWindow.hasOwnProperty("dataLayer")) {
      return;
    }

    if (hit) {
      (this._windowRef.nativeWindow as any).dataLayer.push(hit);
    }
  }
}
